import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const Materials = () => {
  return (
    <Box component="section" className="materials" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h6"
          component="p"
          align="center"
          color="text.secondary"
        >
          Материалы конференции будут опубликованы здесь.
        </Typography>
      </Container>
    </Box>
  );
};

export default Materials;
